import { AffectedStaff } from '../../lib/types/models/affectedStaff/affected-staff'
import { AffectedStaffRequestInput } from '../../lib/types/models/affectedStaff/affected-staff-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createAffectedStaff(input: AffectedStaffRequestInput) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.create.url, null))
    .post<AffectedStaff>(input)
}
